module.exports = __webpack_public_path__ + "static/Icons_DownpAssist_active-d0915126b10a65c754f5af7a5d0c0e71.png";